export default __webpack_public_path__ + "assets/front/scss/editorial.b2eafb62d458825cb54e4ab2393c642c.css";